import React from 'react';
import { Gallery } from 'components/Gallery';
import { Grid } from 'react-bootstrap';

const GalleryView = props => {
  return (
    <Grid>
      <Gallery />
    </Grid>
  );
};

export default GalleryView;



// WEBPACK FOOTER //
// ./src/routes/GalleryView.js